import { IMapFeaturesState } from '../../interfaces';

const mapFeaturesState: IMapFeaturesState = {
	layers: undefined,
	previewFile: undefined,
	requestingCreateLayer: false,
	requestingCreateSource: false,
	requestingLayers: false,
	requestingRemoveLayer: false,
	requestingRemoveSource: false,
	requestingSources: false,
	requestingUpdateLayer: false,
	requestingUpdateSource: false,
	requestingUpdateTileserver: false,
	sources: undefined
};

export default mapFeaturesState;
